import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import DeviationMediaService from '../../../../utils/DeviationMediaService';
import Torpedo from '../../../../Torpedo';
import EditorDeviationLink from '../../../MonoView/_partials/DeviationLink';
import Thumb from '../../../ThumbView';
const GalleryTorpedo = ({ deviations, layoutRowAlignment, torpedoRowHeight, width, layoutSpacing, extOptions, itemCropping, linkOverrides })=>{
    const container = {
        width
    };
    const items = [];
    for (const dev of deviations){
        const largest = DeviationMediaService.getThumbDimensions(dev);
        items.push({
            id: dev.deviationId,
            width: largest.width,
            height: largest.height,
            deviation: dev
        });
    }
    let layoutConfig = {
        galleryGutter: true,
        itemSpacingDesktop: 4,
        itemSpacingMobile: 4
    };
    layoutConfig = {
        rowSizeDesktop: torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : 200,
        rowSizeCardDesktop: torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : 200,
        rowSizeMobile: torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : 200,
        rowSizeCardMobile: torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : 200,
        rowSizeMobileLarge: torpedoRowHeight !== null && torpedoRowHeight !== void 0 ? torpedoRowHeight : 200
    };
    if (layoutSpacing !== undefined) {
        layoutConfig = _object_spread_props(_object_spread({}, layoutConfig), {
            itemSpacingDesktop: layoutSpacing !== null && layoutSpacing !== void 0 ? layoutSpacing : 8,
            itemSpacingMobile: layoutSpacing !== null && layoutSpacing !== void 0 ? layoutSpacing : 8
        });
    }
    let rowAlign;
    let gridStyles = {};
    if (layoutRowAlignment) {
        const settingToCss = {
            left: 'flex-start',
            right: 'flex-end',
            center: 'center'
        };
        gridStyles = {
            display: 'flex',
            justifyContent: settingToCss[layoutRowAlignment]
        };
        rowAlign = layoutRowAlignment;
    }
    const refactor_torpedo_layout = useFlag('refactor_torpedo_layout');
    // Key is to help with live preview as torpedo is heavily update protected
    return /*#__PURE__*/ React.createElement("div", {
        className: "daeditor-torpedo-grid",
        style: gridStyles
    }, /*#__PURE__*/ React.createElement(Torpedo, {
        rowAlign: rowAlign,
        key: `torpedo-${itemCropping}`,
        layoutConfig: layoutConfig,
        items: items,
        container: container,
        enableScrollVisibilityOptimisation: false,
        layoutV2: refactor_torpedo_layout,
        renderItem: (props, item, itemStyle)=>{
            const deviation = item.dto.deviation;
            const { width: itemWidth, height: itemHeight } = item;
            return /*#__PURE__*/ React.createElement("div", {
                className: "daeditor-torpedo-grid-item",
                key: `torpedo-${deviation.deviationId}`,
                style: _object_spread({
                    width: itemWidth,
                    height: itemHeight
                }, itemStyle),
                "data-deviation": JSON.stringify(deviation)
            }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
                link: (extOptions === null || extOptions === void 0 ? void 0 : extOptions.canLink) ? linkOverrides === null || linkOverrides === void 0 ? void 0 : linkOverrides[deviation.deviationId] : undefined,
                deviation: deviation,
                "data-deviationId": (extOptions === null || extOptions === void 0 ? void 0 : extOptions.canLink) ? deviation.deviationId : undefined
            }, /*#__PURE__*/ React.createElement(Thumb, {
                deviation: deviation,
                width: itemWidth,
                height: itemHeight,
                allowPreviewUsage: true,
                noCropping: itemCropping === 'crop' ? true : false
            })));
        }
    }));
};
GalleryTorpedo.displayName = 'GalleryTorpedo';
export default GalleryTorpedo;

//# sourceMappingURL=GalleryTorpedo.js.map